// apps/admin/src/features/quotes/components/QuotesPage.tsx
import { QuoteDataProvider } from '../context/QuotesContext';
import Quotes from './Quotes';
import { usePageLoadTracking } from '../../../hooks/usePerformanceTracking';
import { useSetPageMeta } from '../../../hooks/usePageMeta';


/**
 * QuotesPage - A page wrapper component for the Quotes feature
 * 
 * This component serves as the main entry point for the quotes system.
 * It wraps the Quotes component with its dedicated QuoteDataProvider to ensure
 * proper context isolation from the original quotes system.
 * 
 * Key Features:
 * - Provides isolated data context for Quote operations
 * 
 * Usage:
 * - Use this component in routing (see App.tsx route: /quotes)
 * - Do not use the raw Quotes component directly without this wrapper
 * - The provider ensures all quote-related hooks have proper context access
 * 
 * @returns JSX element containing the quotes management interface
 */
export default function QuotesPage() {
  // Set page metadata
  useSetPageMeta({
    title: 'Quotes',
    description: 'Manage quotes'
  });

  usePageLoadTracking('quotes-page');
  
  return (
    <QuoteDataProvider>
      <Quotes />
    </QuoteDataProvider>
  );
}
